import { render, staticRenderFns } from "./Sizes.vue?vue&type=template&id=3dd7db49&scoped=true"
import script from "@/views/Settings/Sizes/Sizes.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Sizes/Sizes.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Sizes/sizes.scss?vue&type=style&index=0&id=3dd7db49&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7db49",
  null
  
)

export default component.exports